import React, {useState} from "react";
import PropTypes from 'prop-types';
import styles from './SensorAssignment.module.css';
import QrScanComp from '../../../../components/QrScanComp';

const SensorAssigment = ({sensorGroupList, onQRCodeScanned, selectedStation, closePopup}) => {
   
    const [openQRScannerModal, setQRScannerModal] = useState(false);
    const [fieldValue, setFieldValue] = useState([]);
    const validateExtractQRCode = (qrLink) => {
        if (qrLink && qrLink.text.includes('?')) {
          return qrLink && qrLink.text.split('=').slice(-1)[0];
        }
        return qrLink && qrLink.text.split('/').slice(-1)[0];
      };
    const handleQRScan = (data) => {
        if (data && data.text.includes('/s/')) {
          const scanCode = validateExtractQRCode(data);
          setQRScannerModal(false);
          setFieldValue('sensorCodes', scanCode);
          onQRCodeScanned && onQRCodeScanned(scanCode);
        }
      };

    return(
    <div className={styles.container}>
      <span className={styles.close} onClick={closePopup}>X</span>
      <div className={styles.subTitle}>Fit the barcode completely into the box below.</div>        
          <div className="row mx-0 justify-content-center border-radius=1.8vh">
                  <div className="col-12 form-group">
                    <QrScanComp handleScan={handleQRScan} onError={() => {}} />
                  </div>
           </div>
        </div>
    )
};

export default SensorAssigment;

SensorAssigment.propTypes = {
  sensorGroupsList: PropTypes.array,
  onQRCodeScanned: PropTypes.func,
  closePopup: PropTypes.func,
};

SensorAssigment.defaultProps = {
  sensorGroupsList: [],
  onQRCodeScanned: () => { },
  closePopup: () => { },
};